var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"kv"},[_vm._l((_vm.items),function(item,i){return [_c('dt',{key:'k-' + i},[_vm._v(_vm._s(item.k))]),_c('dd',{key:'v-' + i,class:{ 'kv-mono': item.mono }},[_vm._v(_vm._s(item.v))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }